// To Do list
// *- cuando re refresca la cta cte, hay que cerrar todos los drill-downs (done)
// *- botón calculadora no anda para todos los casos... // probé Dondo con 150K y marcó solo un comprbante (done)
// - Cuándo aparece el botón pagar? no debería ni bien agrego un monto <> 0 o al menos "calculo" facturas a seleccionar?
// - luego de pagar, no se refresca la cta cte.
// - problema en el pago con recargo. Ver último ejemplo del documento de test

import { React, lazy, Suspense, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import CboPeriodos from "./CboPeriodos";
import CboTipoLiq from "./CboTipoLiq";
import { formatDate, formatCurrency, monthDiff }  from "./format.js"
import ModDetPago from "./ModDetPago.js";

 let intipoLiq = 0;
 let inperiodoLiq = 0;

const CompteDet = lazy ( () => import('./CompteDet'));
const CompteApli = lazy ( () => import('./CompteApli'));

const CtaCte = () => {

   const usenav = useNavigate();

   const [aluid, setAluid] = useState("")  
   const [grupo, setGrupo] = useState();
   const [empresa, setEmpresa] = useState();
   const [tipoLiq, setTipoLiq] = useState("")  
   const [periodoLiq, setPeriodoLiq] = useState("") 
   const [noteditable, setNotEditable] = useState(true);
   // importe que está pagando el padre/cliente
   const [importePagar, setImportePagar] = useState(0);
   // total de las Facturas seleccionadas
   const [totFactSel, setTotFactSel] = useState(0);
   const [verPendiente, setverPendiente] = useState(true);
   const [conRecargo, setConRecargo] = useState(true);
   const [unaCtaCte, setCtaCte] = useState([]); 
   const [listCompte, setListCompte] = useState([]);

   const [refreshCta, setRefreshCta] = useState(false);
  


  const [showModalFPago, setShowModalFPago] = useState(false);
//  const [lFormaPago, setLFormaPago] = useState({});

  const [fecPago, setFecPago] = useState(new Date().toISOString().split('T')[0]);
  const [fPagoDet, setFPagoDet] = useState([{"fpago": 0, "Comprob" : '', "Descrip" : '', "Importe" : 0 }]); 


   const location = useLocation();





const truncateToTwoDecimals = (value) => {
  // Multiply the value by 100 to shift the first two decimal places to the left of the decimal point
  const scaledValue = value * 100;

  // Truncate the fractional part using Math.trunc()
  const truncatedScaled = Math.trunc(scaledValue);

  // Divide the result back by 100 to return to the original magnitude
  return truncatedScaled / 100;
};

useEffect(() => {

    var { unalumno } = location.state || {};

    console.log('Dato alumno cta cte:', unalumno[0].Alu_IdAlu);
    setAluid(unalumno[0].Alu_IdAlu);
    setGrupo(unalumno[0].Gru_IdGru);
    setEmpresa(unalumno[0].Emp_IdEmp);

     let unLiq = new Object();

        unLiq.alumno = unalumno[0].Alu_IdAlu;
       
      var url;
      var json2in, json2out;
      // indico el comienzo del procesamiento
      
     
      try { 
 
        json2in = JSON.stringify(unLiq);
        console.log(json2in);

        url = `${process.env.REACT_APP_API_URL}/cta/getone`;
 
  
        var options = {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          mode: 'cors',
          credential : 'include',
          body:  json2in,
          
          };
        
        fetch(url, options)
        .then( response => response.json())
        .then( data => {
          json2out = data.data;
           if(json2out)
           { 
              
              console.log("ctacte", json2out);
              // agregarle un atributo para gestionar las filas seleccionadas

              const nvaCtaCte = json2out.map(unaCtaCte => {
                      return {
                        ...unaCtaCte,          // Copy all existing properties
                        checked: false,       // para llevar el control de los comprobantes seleccionados
                        visDetail : false,     // para llevar el control de mostrar el detalle
                        visCompens : false     // para llevar el control de mostrar la compensación
                      };
              });
              setCtaCte(nvaCtaCte);
              console.log("cta cte con checked", nvaCtaCte);
           }
        }).finally ( () => {
           

       })
    } catch (error) {
        console.log(error);
        
    }




   
}, [refreshCta]) 

//   y calcular nuevo monto total seleccionado
useEffect(() => {
      
    var totalSelec = 0;
     unaCtaCte.map((unCtaCte, index) => {
      if (unCtaCte.checked)
        {
          totalSelec = totalSelec + unCtaCte.Cte_Saldo + truncateToTwoDecimals( ( conRecargo ? (unCtaCte.Cte_Saldo*(1.05 ** (monthDiff(new Date(), unCtaCte.Cte_Fecha)))) - unCtaCte.Cte_Saldo  : 0));
          
        }
      });
      
     setTotFactSel(totalSelec);
}, [unaCtaCte, conRecargo]) 
   
const closeFormaPago = (salida) => 
  {
    if (salida == 1) 
    {
     // procesar pago
     // refrescar ventana
     handlePagar();
     setTotFactSel(0);
    }  
    {
     // canceló
    }
    setShowModalFPago(false)
  }

const handleDetail = (inx) => {
    console.log("ver detalle ", inx)
   // marcar el que se acaba de seleccionar/deseleccionar
      const nvaCtaCte = unaCtaCte.map((unCtaCte, index) => {

        if (index === inx) {
          if (unCtaCte.visCompens && !unCtaCte.visDetail)
          { 
          return { ...unCtaCte, visDetail: !unCtaCte.visDetail, visCompens : false };
          }
          else
          {
            return { ...unCtaCte, visDetail: !unCtaCte.visDetail };
          }
        }
        else
        {
          return { ...unCtaCte }
        };
    })
    
   setCtaCte(nvaCtaCte);

   // Buscar detalle de documento
   // F: detalle de factura
   // R: detalle de recibo 
   
}
const handleCompens = (inx) => {
   console.log("ver compensación ", inx)
   // marcar el que se acaba de seleccionar/deseleccionar
      const nvaCtaCte = unaCtaCte.map((unCtaCte, index) => {

        if (index === inx) {
          if (unCtaCte.visDetail && !unCtaCte.visCompens )
          { 
          return { ...unCtaCte, visCompens: !unCtaCte.visCompens, visDetail : false };
          }
          else
          {
            return { ...unCtaCte, visCompens: !unCtaCte.visCompens };
          }
        }
        else
        {
          return { ...unCtaCte }
        };
    })
    
   setCtaCte(nvaCtaCte);

   // Buscar detalle de documento
   // F: detalle de factura
   // R: detalle de recibo
   
}


const handlePasar = () => {
   setImportePagar(truncateToTwoDecimals(totFactSel));
   
}





const handlePagar = () => {
   //event.preventDefault();

console.log("Detalle forma de Pago", fPagoDet);
//  Validar que si (1)  el importe a pagar es mayor que el importe de facturas seleccionadas y
//                 (2) hay facturas sin seleccionar
//  
//             no enviar el request del pago   ( habría que seleccionar más facturas) 
let saldoTotDeuda = 0;
let okPagar = false;
let factSinCheck = false;
 unaCtaCte.map (( unCtaCte, index ) => {
     //console.log("vuelta: ", index, autoSelImpo, salImpoPagar );
     saldoTotDeuda = saldoTotDeuda + unCtaCte.Cte_Saldo;
     if (unCtaCte.Cte_Saldo && !unCtaCte.checked)
     {
      factSinCheck = true;
     }
    }
    )

console.log("validar si paga: ", importePagar, totFactSel, factSinCheck);
     if ((importePagar > totFactSel ) && ( factSinCheck))
     { 
      // mostrar mensaje de error
     }

     else
     {

        let listCtes = new Object();

        listCtes.grupo = grupo;
        listCtes.empresa = empresa;
        listCtes.listcomptes = listCompte;
        listCtes.totfact = totFactSel;
        listCtes.impopago = importePagar;
        listCtes.fecpago = fecPago;
        listCtes.fPagoDet = fPagoDet;
       
      var url;
      var json2in, json2out;
      // indico el comienzo del procesamiento
      
     
      try { 
 
        json2in = JSON.stringify(listCtes);
        console.log(json2in);

        url = `${process.env.REACT_APP_API_URL}/pag/setmany`;
 
  
        var options = {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          mode: 'cors',
          credential : 'include',
          body:  json2in,
          
          };
        
        fetch(url, options)
        .then( response => response.json())
        .then( data => {
          json2out = data.data[0];
           if(json2out[1])
           { 
              
              console.log("pagos many", json2out);
              
              ///setCtaCte(json2out);
              //console.log("la liq", json2out.data[0][0].Alu_IdAlu);
           }
        }).finally ( setRefreshCta(!refreshCta))
    } catch (error) {
        console.log(error);
        
    }



  } // else si cumple las condiciones de validación para ir a registrar el pago
   
 };  

// Calcular y pedir forma de pago

const handleCalcular = () => {
 //  event.preventDefault()
 let autoSelImpo = 0;
 let salImpoPagar;
salImpoPagar = importePagar;
setListCompte([]);
   const nvaCtaCte =  unaCtaCte.map (( unCtaCte, index ) => {
     //console.log("vuelta: ", index, autoSelImpo, salImpoPagar );
     // //  (conRecargo ? (unolista.Cte_Saldo*(1.05 ** (monthDiff(new Date(), unolista.Cte_Fecha))))  : unolista.Cte_Saldo )


     if ((unCtaCte.Cte_Saldo ) && (salImpoPagar) )
     { 
      if (unCtaCte.Cte_Saldo < salImpoPagar)
      {  
        autoSelImpo = autoSelImpo + unCtaCte.Cte_Total;
        salImpoPagar = salImpoPagar - unCtaCte.Cte_Total;
      }
      else 
      {
        salImpoPagar = 0
      }
        // console.log("vuelta: ", index, autoSelImpo, salImpoPagar );
          setListCompte( ListCompte => [...ListCompte, unCtaCte.Cte_IdCte]);
        return { ...unCtaCte, checked: true };
     }
     else
     {
      
      // console.log("vuelta: ", index, autoSelImpo, salImpoPagar );
      return { ...unCtaCte, checked: false };
     }


 

    }
    )
setCtaCte(nvaCtaCte);
setFPagoDet([{"fpago": 0, "Comprob" : '', "Descrip" : '', "Importe" : 0 }]); 
setShowModalFPago(true);

   
};
const handlePendientes = () => {
 //  event.preventDefault()
 
   setverPendiente(!verPendiente);
  if (!verPendiente)
  {
   const nvaCtaCte =  unaCtaCte.map (( unCtaCte, index ) => {
     //console.log("vuelta: ", index, autoSelImpo, salImpoPagar );
     // //  (conRecargo ? (unolista.Cte_Saldo*(1.05 ** (monthDiff(new Date(), unolista.Cte_Fecha))))  : unolista.Cte_Saldo )

        return { ...unCtaCte, visDetail : false, visCompens: false };

  })
    setCtaCte(nvaCtaCte);

  }
   
};

const handleConRecargo = () => {
 //  event.preventDefault()
   setConRecargo(!conRecargo);
   
};

const handleSelect = (event, el, inx) => {
 //  event.preventDefault()
 /*  if(unaCtaCte[inx].checked)
   {
     console.log("quitar", el);
     setListCompte(prevItems => {
      return prevItems.filter((item, index) => item !== el);
      });
   }
   else
   {      
    console.log("poner", el);
      setListCompte( ListCompte => [...ListCompte, el]);
   }
   */
  
   setListCompte([]);
   // marcar el que se acaba de seleccionar/deseleccionar
      const nvaCtaCte = unaCtaCte.map((unCtaCte, index) => {
        if (unaCtaCte.checked)
        {
          setListCompte( ListCompte => [...ListCompte, unaCtaCte.Cte_IdCte ]);
        }
        if (index === inx) {
          
          return { ...unCtaCte, checked: !unCtaCte.checked };
        }
        else
        {
          return { ...unCtaCte }
        };

      });
  console.log("lista comptes: ", listCompte);
  console.log("nva cta cte ", nvaCtaCte) ;
     setCtaCte(nvaCtaCte);




   
 };  

const handleTipoLiqChange = (event) => {
   event.preventDefault()
   console.log("TipoLiq", event.target.value);
    setTipoLiq(event.target.value);
    intipoLiq = event.target.value;

  };  
const handlePeriodoLiqChange = (event) => {
   event.preventDefault()
   console.log("Período", inperiodoLiq);
   console.log("Período evento:", event.target.value);
    setPeriodoLiq(event.target.value);
    inperiodoLiq = event.target.value;

    console.log("Período2", inperiodoLiq);
  };


  async function handleKeyDown (ev)
  {
     if (ev.key === 'Enter') {
       handleCalcular();
     }


  }



let saldo = 0;
    return (
    <>

<div className="container-fluid">

{aluid}



 <div className="row mb-1 border-primary p-2">

          <div className="col-lg-offset-0 col-lg-2 col-xs-3 col-sm-2">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Facturas seleccionadas</label>
                <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" value={formatCurrency(totFactSel)} disabled={true}/>
              </div>
          </div>  
        <div className="col-lg-offset-0 col-lg-1 col-xs-1 col-sm-1">
                     <div className="col  col-1 text-center border-info p-2 m-3">
                       <button type="button" className="btn btn-info"  id="clear" onClick={handlePasar}  ><i className="bi bi-arrow-right"></i></button>
                     </div>
        </div>          
          <div className="col-lg-offset-0 col-lg-2 col-xs-3 col-sm-2">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Importe a Pagar</label>
                <input type="text" className="form-control" id="exampleInputEmail1" placeholder=""  onKeyDown={handleKeyDown} onChange={e => {setImportePagar(e.target.value)}}  value={importePagar} />
              </div>
          </div>          
        <div className="col-lg-offset-0 col-lg-1 col-xs-2 col-sm-1">
              <div className={ (importePagar != 0) ?  "col  col-1 text-center border-info p-2 m-2" :  "col  col-1 text-center border-info p-2 m-2 d-none"}>
                <button type="button" className="btn btn-info"  id="calcu" onClick={handleCalcular}  >Pagar</button>
              </div>
        </div>        
      

       

  </div>
 <div className="row mb-1 border-primary p-1">
                               
              <div className="col  col-2 text-center border-info p-1 m-1">
                   <div className="checkbox">
                   <label>
                        <input type="checkbox" onChange={handlePendientes} value="" checked={verPendiente} />
                           &nbsp; Solo pendientes </label>
                   </div>
             </div>
              <div className="col  col-2 text-center border-info p-1 m-1">
                   <div className="checkbox">
                   <label>
                        <input type="checkbox" onChange={handleConRecargo} value="" checked={conRecargo} />
                           &nbsp; Con recargo </label>
                   </div>
             </div>             
                     
  </div>
   

          
     <table v= { saldo = 0} className= {(aluid ) ? "table table-striped table-info table-hover m3" : "table table-striped table-info table-hover m3 d-none" }>

  <thead>
    <tr className="row" >
      <th className="col-1" >Detail</th>
      <th className="col-1" >Selec</th>
      <th className="col-2" >Cuota</th>
      <th className="col-2" >Compr</th>
      <th className="col-1" >Fecha</th>
      <th className="col-1" >Importe</th>
      <th className="col-1" >Saldo</th>
      <th className="col-1" >Recargo</th>
      <th className="col-1" >Acumulado</th>


    </tr>
  </thead>
<tbody>
    
{ 

   
   unaCtaCte.map (( unolista, index ) => (
    
    <>
    <tr key={index+'_row'}  className={ !verPendiente || ( verPendiente && (unolista.Cte_Saldo != 0)) ? "row" : "row d-none"}>
              
                 <td key={index+'_calc'} className="col-0 d-none">
                {saldo = saldo + (conRecargo ? (unolista.Cte_Saldo*(1.05 ** (monthDiff(new Date(), unolista.Cte_Fecha))))  : unolista.Cte_Saldo )}
              </td> 
              
              <td key={index+'_compens'} className="col-1">
                     <i key={index+'_icono1'} className={unolista.visCompens ? "bi bi-arrow-bar-up" : "bi bi-arrow-bar-down"} onClick={() => handleCompens(index)}></i>&nbsp;&nbsp;
                     <i key={index+'_icono2'} className="bi bi-receipt" onClick={() => handleDetail(index)}></i>
              </td> 

              <td key={index+'_selec'} className="col-1">
                      <input key={index+'_cbox'}  type="checkbox" className={(unolista.Cte_Tipo=='F') && (unolista.Cte_Saldo != 0) ? "" : "d-none"} value="" onChange={e => {handleSelect(e, unolista.Cte_IdCte, index)}} checked={unolista.checked}/>
              </td> 
              <td key={index+'_periodo'} className="col-2">
                { unolista.Per_Nombre }
              </td> 

              <td key={index+'_nrocomp'} className="col-2">
                { unolista.Cte_Tipo + ' - ' + unolista.Cte_NroComp }      
              </td> 
               <td key={index+'_fecha'} className="text-end col-1">
                { formatDate(unolista.Cte_Fecha) }
              </td> 
               <td key={index+'_importe'} className="text-end col-1">
                { formatCurrency(unolista.Cte_Total) }
              </td>               
               <td key={index+'_importesaldo'} className="text-end col-1">
                { formatCurrency(unolista.Cte_Saldo) }
              </td>              
              <td key={index+'_recargo'} className="text-end col-1">
                { formatCurrency(conRecargo ? (unolista.Cte_Saldo*(1.05 ** (monthDiff(new Date(), unolista.Cte_Fecha)))) - unolista.Cte_Saldo  : 0)}
              </td> 
              <td key={index+'_saldo'} className="text-end col-1">
                { 
                  formatCurrency(saldo) }
              </td> 


   

    </tr> 
 
  
    <tr key={index+'_rowdet2'}  className={(unolista.visDetail || unolista.visCompens) ? "row table-primary" : "row table-primary  d-none"} >
    { unolista.visCompens && ( <Suspense>
      <CompteApli 
       tipo = {unolista.Cte_Tipo}
        comprobante={unolista.Cte_IdCte} 
        disabled={noteditable }   /> 
      </Suspense>)
    }
    { unolista.visDetail && ( <Suspense>
      <CompteDet 
       tipo = {unolista.Cte_Tipo}
        comprobante={unolista.Cte_IdCte} 
        disabled={noteditable }   /> 
      </Suspense>)}
  
</tr>
 <tr key={index+'_rowdet4'}  className={unolista.visDetail ? "row" : "row d-none"} >

 </tr>
   </>

)
)

   }
   </tbody>
</table>
      <ModDetPago 
        isOpen={showModalFPago} 
        onClose={closeFormaPago} 
        fecPago={fecPago}
        setFecPago={setFecPago}
        fPagoDet={fPagoDet}
        setFPagoDet={setFPagoDet}
        inpoValidar = {importePagar}
      />
</div>

    </>
    )

}

export default CtaCte;